import { render } from "./RegistrationActivation.vue?vue&type=template&id=069c65ec&scoped=true&bindings={\"activationSuccess\":\"data\",\"postRegistrationActivation\":\"options\"}"
import script from "./RegistrationActivation.vue?vue&type=script&lang=js"
export * from "./RegistrationActivation.vue?vue&type=script&lang=js"

import "./RegistrationActivation.vue?vue&type=style&index=0&id=069c65ec&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-069c65ec"

export default script